module.exports = __webpack_public_path__ + "static/media/thumbs_captura-de-pantalla-2012-07-02-a-las-18-57-21.0499aa4b.png";